import React from 'react'
import DeliveryWizard from '@components/DeliveryWizard'
import {useState} from '@hooks/useState'

export default function AddressModals() {
  const [openOptions, setOpenOptions] = useState(false)

  return (
    <>
      {openOptions ? (
        <DeliveryWizard.AsModal
          isOpen={openOptions}
          onClose={() => setOpenOptions(false)}
          actionLocation="cart"
        />
      ) : null}
    </>
  )
}
